<template>
  <teleport to="body">
    <div
      v-if="openModal"
      class="modal"
      @click.self.prevent="
        openModal = !openModal;
        openNotesModal = false;
      ">
      <div v-if="getKiosk" class="container">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="openModal = !openModal" />
        <div v-if="!eftposBusy" class="product-list">
          <h3>Do you have everything you want...</h3>
          <div class="product-container">
            <div class="items" v-for="product in products" :key="product">
              <img v-if="product.image" :src="product.image" alt="image of product" />
              <div v-else class="no-image">Image coming soon...</div>
              <div class="content">
                <h4>{{ product.name }}</h4>
                <CurrencyFormatter :value="product.price" :currency="currency" />
                <p v-if="product.modifier_list.length">Modifiers:</p>
                <ul v-if="product.modifier_list.length">
                  <li v-for="modifier in product.modifier_list" :key="modifier">
                    {{ modifier.name }}
                    <span v-if="modifier.price > 0"><CurrencyFormatter :value="modifier.price" :currency="currency" /></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <button class="pay-btn" @click.stop.prevent="sendToEftpos(total)"><CurrencyFormatter :value="total" :currency="currency" /> Pay with EFTPOS</button>
      </div>
      <div v-if="getKiosk && eftposBusy" id="eftpos-spinner">
        <LoadingSpinner :spinnerMessage="'Please use card reader to complete you order'" />
      </div>

      <div v-if="!getKiosk" class="outer">
        <font-awesome-icon icon="fa-xmark" class="exit bump-right" @click="(openModal = !openModal), closePaymentOption()" />
        <form @submit.stop.prevent>
          <div class="details">
            <!-- <h2 class="remaining">
            <span class="label" v-if="remaining >= 0">Balance</span>
            <span class="label" v-if="remaining < 0">Change for Customer</span>
            <span class="value">{{ '$' + remaining.toFixed(2) }}</span>
            </h2> -->
            <ul class="log" v-if="showLog">
              <li v-bind:key="idx" v-for="(payment, idx) in payments">{{ payment.type }} - <CurrencyFormatter :value="payment.value" :currency="currency" /></li>
            </ul>
            <div class="notes">
              <div>
                <h4>Name</h4>
                <input type="text" v-model="name" placeholder="Customer Name..." />
              </div>
              <!-- <div v-if="allergens">
                <h4 v-if="siteSettings && siteSettings.notesRequired">Allergens</h4>
                <textarea v-model="notes" placeholder="Add Allergen Notes" />
              </div> -->
              <div>
                <h4 v-if="siteSettings && siteSettings.notesRequired">Notes</h4>
                <textarea v-if="siteSettings && siteSettings.notesRequired" v-model="notes" placeholder="Order Notes..." />
              </div>
              <div v-if="siteSettings.trackAllergens" class="customer-allergens">
                <h4>Customers Allergies</h4>
                <AllergenList :unlisted="true" :allergens="getCustomerAllergenList" />
              </div>
            </div>

            <div>
              <div class="delivery" v-if="siteSettings.delivery_options.length > 1">
                <span v-bind:key="delivery_option" @click="selectDelivery(delivery_option)" v-for="delivery_option in siteSettings.delivery_options">
                  <input type="radio" v-model="delivery" :class="delivery_option" name="option" :value="delivery_option" />{{ delivery_option }}
                </span>
              </div>
            </div>
            <div v-if="futurePickup" class="future-pickup-options">
              <div class="fp-options-inner">
                <h4>Date of Pick Up</h4>
                <input class="date-picker" type="date" v-model="futurePickupDate" />
                <input v-if="includePickupTime" class="date-picker" type="time" v-model="futurePickupTime" />
                <label class="time-toggle">
                  <input type="checkbox" v-model="includePickupTime" /> Include pick-up time
                </label>
              </div>
              <div class="fp-options-inner">
                <h4>Pick Up Location</h4>
                <select v-model="location">
                  <option value="" disabled>Please select one</option>
                  <option v-for="(site, idx) in $store.getters.siteSettings.pickupSites" :key="idx" :value="site">
                    {{ site.toUpperCase() }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="discounts.length">
              <h4>Discounts</h4>
              <div class="payments">
                <button class="button is-primar action-colour" @click="applyDiscount(discount)" :key="discount" v-for="discount in activeDiscounts()">
                  <p class="discount-tag" v-if="discount.value.type">{{ discount.value.name }} <CurrencyFormatter :value="discount.value.value" :currency="currency" /></p>
                  <p class="discount-tag" v-else>{{ discount.value.name }} {{ discount.value.value + "%" }}</p>
                </button>
              </div>
            </div>
            <div v-if="errors">
              <div class="errors" v-for="(error, index) in errors" :key="index">
                {{ error }}
              </div>
            </div>

            <div v-if="paymentProccessing" class="svg-spinner">
              <LoadingSpinner spinner-message="Processing Payment..." />
            </div>

            <div>
              <h4>Payments</h4>
              <div class="payments">
                <button
                  v-if="siteSettings && siteSettings.eftpos_pay && remaining > 0 && !eftposBusy"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="sendToEftpos(splitTotal)">
                  <div>
                    EFTPOS
                    <span v-if="remaining > 0"><CurrencyFormatter :fontSize="'large'" :value="splitTotal" :currency="currency" /></span>
                  </div>
                  <div class="pencil-button" @click.stop.prevent="openPaymentOption('eftpos')">
                    <font-awesome-icon icon="pencil" style="color: var(--text-colour)" />
                  </div>
                </button>
                <button
                  v-if="siteSettings && siteSettings.eftpos_pay && remaining > 0 && eftposBusy && !eftposSig"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="cancelEftpos">
                  <div v-if="activeTerminal == 'eftpos_nz'">Cancel EFTPOS</div>
                  <div v-if="activeTerminal == 'smartpay'">Cancel EFTPOS on the terminal</div>
                  <div v-if="activeTerminal == 'windcave'">Cancel EFTPOS</div>
                </button>
                <button
                  v-if="siteSettings && siteSettings.cash_pay && remaining > 0"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="payCash(splitTotal)">
                  <div>
                    Cash
                    <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                  </div>
                  <div class="pencil-button" @click.stop.prevent="openPaymentOption('money')">
                    <font-awesome-icon icon="pencil" style="color: var(--text-colour)" />
                  </div>
                </button>
                <button
                  v-if="siteSettings && siteSettings.cash_out && remaining > 0 && !eftposBusy"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="showKeyPad = true">
                  <div>
                    EFTPOS & Cashout
                    <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                  </div>
                </button>
                <button
                  class="button is-primary button-spacing action-colour"
                  v-if="siteSettings && siteSettings.eftpos_pay && remaining > 0 && eftposBusy && !eftposSig"
                  @click.stop.prevent="manualEftposPayment(splitTotal)">
                  <div>Manual Eftpos Payment</div>
                </button>
                <div v-if="siteSettings && siteSettings.eftpos_pay && remaining > 0 && eftposBusy && eftposSig" class="button is-primary button-spacing action-colour">
                  <div>Approve Signature?</div>
                  <div class="sig-btns">
                    <button @click.stop.prevent="declineSig">No</button>
                    <button @click.stop.prevent="acceptSig">Yes</button>
                  </div>
                </div>
                <button
                  v-if="remaining > 0 && siteSettings && siteSettings.stripe"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="chargeStripe(splitTotal)">
                  <div>
                    Stripe
                    <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                  </div>
                </button>
                <button v-if="siteSettings && siteSettings.eftpos_pay && remaining <= 0" class="button is-primary action-colour" @click="$store.dispatch('deleteEftposPayment')">
                  Cancel Last Payment
                </button>
                <button v-if="siteSettings && siteSettings.post_pay && remaining > 0" class="button is-primary action-colour" @click="payLater(splitTotal)">
                  Pay Later
                  <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                </button>
                <button v-if="siteSettings && siteSettings.accounts && remaining > 0" class="button is-primary action-colour" @click.stop.prevent="openPaymentOption('account')">
                  Account
                  <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                </button>
                <button v-if="siteSettings && siteSettings.vouchers && remaining > 0" class="button is-primary action-colour" @click.stop.prevent="openPaymentOption('voucher')">
                  Voucher
                  <span v-if="remaining > 0"><CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                </button>
                <button
                  v-if="siteSettings && siteSettings.centrapay && remaining > 0 && !eftposBusy && !sentToCentrapay.active"
                  class="button is-primary action-colour"
                  @click.stop.prevent="sendToCentrapay(remaining)">
                  Centrapay
                  <span v-if="remaining > 0"> <CurrencyFormatter :value="splitTotal" :currency="currency" /></span>
                  <!-- <div for when we can edit centrapay amounts
                    class="pencil-button"
                    @click.stop.prevent="openPaymentOption('centrapay')">
                    <font-awesome-icon
                      icon="pencil"
                      style="color: var(--text-colour)"
                    />
                  </div> -->
                </button>
                <button
                  v-if="siteSettings && siteSettings.centrapay && remaining > 0 && sentToCentrapay.active"
                  class="button is-primary button-spacing action-colour"
                  @click.stop.prevent="cancelCentrapay">
                  <div>Cancel CENTRAPAY</div>
                </button>
                <button v-if="siteSettings && siteSettings.refund_allowed && remaining <= 0" class="button is-primary action-colour" @click="refund(total)">
                  Refund<span v-if="remaining <= 0"><CurrencyFormatter :value="total" :currency="currency" /></span>
                </button>
              </div>
              <button v-show="products.length" v-if="remaining === 0 || remaining <= 0" class="button is-primary action-colour complete" @click="completeTransaction">
                Complete Transaction
              </button>
            </div>
          </div>
          <div class="paymentOption" v-if="paymentOptionOpened">
            <!-- <font-awesome-icon icon="fa-circle-xmark" class="exit" @click="closePaymentOption" /> -->
            <font-awesome-icon icon="fa-arrow-left" class="exitPaymentOption" @click="closePaymentOption()" />

            <!-- custom cash amount -->
            <h2 v-if="moneyShow">Enter a Custom Cash Amount</h2>
            <div :class="moneyShow ? 'money' : 'no-money'">
              <div class="cashLeft">
                <input class="input" type="number" name="customAmount" min="1" :disabled="!moneyShow" v-model="customAmount" placeholder="Enter Amount" />
                <!-- <select
                  id="showmethemoney"
                  name="dropdown"
                  class="dollarBills"
                  v-model="customAmount"
                  :disabled="!moneyShow">
                  <option value="100">$100</option>
                  <option value="50">$50</option>
                  <option value="20" selected>$20</option>
                  <option value="10">$10</option>
                  <option value="5">$5</option>
                </select> -->
                <div class="dollarBillOptions">
                  <button class="button is-primary button-spacing action-colour" :disabled="remaining <= 0" @click="payCash(100.0)">
                    <CurrencyFormatter :value="100.0" :currency="currency" />
                  </button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(50.0)">
                    <CurrencyFormatter :value="50.0" :currency="currency" />
                  </button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(20.0)">
                    <CurrencyFormatter :value="20.0" :currency="currency" />
                  </button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(10.0)">
                    <CurrencyFormatter :value="10.0" :currency="currency" />
                  </button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(5.0)"><CurrencyFormatter :value="5.0" :currency="currency" /></button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(2.0)"><CurrencyFormatter :value="2.0" :currency="currency" /></button>
                  <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="payCash(1.0)"><CurrencyFormatter :value="1.0" :currency="currency" /></button>
                  <!-- Change Due: ${{ changeDue }} this seems like it isnt change due? -->
                </div>

                <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="customAmount > 0 ? payCash(customAmount) : null, closePaymentOption()">
                  CASH <CurrencyFormatter :value="customAmount" :currency="currency" />
                </button>
              </div>
              <div class="cashRight">
                <div class="keypad">
                  <div class="keypad-display">
                    <h2>Amount: {{ amount }}</h2>
                    <font-awesome-icon icon="fa-delete-left" class="exit" @click="clearInput" size="xl" />
                  </div>
                  <div class="keypad-buttons">
                    <button v-for="key in keys" :key="key" @click="addKey(key)">
                      {{ key }}
                    </button>
                    <button @click.stop.prevent="addKey('.')">.</button>
                    <button @click.stop.prevent="addKey(0)">0</button>
                    <button @click.stop.prevent="enterCustomAmount(amount), customAmount > 0 ? payCash(customAmount) : null, closePaymentOption()">Enter</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- custom eftpos amount -->
            <h2 v-if="eftposShow">Custom Amount</h2>
            <div :class="eftposShow ? 'eftpos' : 'no-eftpos'">
              <div class="eftposLeft">
                <div class="itemsAddedToEftpos">
                  <p>Items Added to EFTPOS:</p>
                  <ul>
                    <li v-for="item in itemEftposList" :key="item.hash">
                      {{ item.name }} - <CurrencyFormatter :value="item.price" :currency="currency" />
                      <span class="remove-item" @click="removeItemFromEftpos(item)"><font-awesome-icon class="quantity-icon" icon="trash" /></span>
                    </li>
                  </ul>
                </div>
                <input class="input" type="number" name="customAmount" :disabled="!eftposShow" min="1" v-model="customAmount" placeholder="Enter Amount" />
                <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="customAmount > 0 ? sendToEftpos(customAmount) : null, closePaymentOption()">
                  EFTPOS <CurrencyFormatter :value="customAmount" :currency="currency" />
                </button>
              </div>
              <div class="eftposRight">
                <div class="keypad">
                  <!-- to fixed??? -->
                  <div class="keypad-display">
                    <h2>Amount: {{ amount }}</h2>
                    <font-awesome-icon icon="fa-delete-left" class="exit" @click="clearInput" size="xl" />
                  </div>
                  <div class="keypad-buttons">
                    <button v-for="key in keys" :key="key" @click="addKey(key)">
                      {{ key }}
                    </button>
                    <button @click.stop.prevent="addKey('.')">.</button>
                    <button @click.stop.prevent="addKey(0)">0</button>
                    <button @click.stop.prevent="enterCustomAmount(amount), customAmount > 0 ? sendToEftpos(customAmount) : null, closePaymentOption()">Enter</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- custom centrapay amount -->
            <h2 v-if="centrapayShow">Custom Amount</h2>
            <div :class="centrapayShow ? 'centrapay' : 'no-centrapay'">
              <div class="centrapayLeft">
                <div class="itemsAddedToCentrapay">
                  <p>Items Added to Centrapay:</p>
                  <ul>
                    <li v-for="item in itemCentrapayList" :key="item.hash">
                      {{ item.name }} - <CurrencyFormatter :value="item.price" :currency="currency" />
                      <span class="remove-item" @click="removeItemFromCentrapay(item)"><font-awesome-icon class="quantity-icon" icon="minus-circle" /></span>
                    </li>
                  </ul>
                </div>
                <input class="input" type="number" name="customAmount" :disabled="!centrapayShow" min="1" v-model="customAmount" placeholder="Enter Amount" />
                <button class="button is-primary action-colour" :disabled="remaining <= 0" @click="customAmount > 0 ? sendToCentrapay(customAmount) : null, closePaymentOption()">
                  Centrapay <CurrencyFormatter :value="customAmount" :currency="currency" />
                </button>
              </div>
              <div class="centrapayRight">
                <div class="keypad">
                  <!-- to fixed??? -->
                  <div class="keypad-display">
                    <h2>Amount: {{ amount }}</h2>
                    <font-awesome-icon icon="fa-delete-left" class="exit" @click="clearInput" size="xl" />
                  </div>
                  <div class="keypad-buttons">
                    <button v-for="key in keys" :key="key" @click="addKey(key)">
                      {{ key }}
                    </button>
                    <button @click.stop.prevent="addKey('.')">.</button>
                    <button @click.stop.prevent="addKey(0)">0</button>
                    <button @click.stop.prevent="enterCustomAmount(amount), customAmount > 0 ? sendToCentrapay(customAmount) : null, closePaymentOption()">Enter</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- account search -->
            <h2 v-if="accountShow">Add to Account</h2>
            <div :class="accountShow ? 'account' : 'no-account'">
              <form @submit.stop.prevent role="search" class="search">
                <input id="accountSearch" type="search" placeholder="Search..." autofocus required v-model="searchQuery" />
                <!-- <button @click="search()" type="submit">Go</button> -->
              </form>
              <ul v-if="searches.length" :class="'grid wrapper layout content-gap'">
                <template v-bind:key="search" v-for="search in searches">
                  <li @click="sendToAccount(search.key[0], search.key[1], remaining), closePaymentOption()" class="modifierBox">
                    <div class="box">
                      <p>
                        <span class="modifier-name">Name: {{ search.key[0] }}</span>
                        <span class="modifier-name">ID: {{ search.key[1] }}</span>
                        <span class="modifier-name"><CurrencyFormatter :value="search.value" :currency="currency" /></span>
                      </p>
                      <span></span>
                    </div>
                  </li>
                </template>
              </ul>
            </div>

            <!-- voucher search -->
            <h2 v-if="voucherShow">Debit Voucher</h2>
            <div :class="voucherShow ? 'voucher' : 'no-voucher'">
              <form @submit.stop.prevent role="search" class="search">
                <input id="voucherSearch" type="search" placeholder="Search by voucher ID..." autofocus required v-model="voucherSearchQuery" />
              </form>
              <ul v-if="searches.length" :class="'grid wrapper layout content-gap'">
                <template v-bind:key="search" v-for="search in searches.filter((s) => s.value > 0)">
                  <li @click="sendToVoucher(search.key[0], search.key[1], remaining, search.value), closePaymentOption()" class="modifierBox">
                    <div class="box">
                      <p>
                        <span class="modifier-name">Name: {{ search.key[0] }}</span>
                        <span class="modifier-name">ID: {{ search.key[1] }}</span>
                        <span class="modifier-name">Value: <CurrencyFormatter :value="search.value" :currency="currency" /></span>
                      </p>
                      <span></span>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </form>
        <div class="cart">
          <Cart :itemPay="itemPay" @addItemToPayment="addItemToPayment" />
        </div>
      </div>
      <KeyPad :keyPad="showKeyPad" @enter="eftposCashOut" @close="showKeyPad = false" />
    </div>
  </teleport>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import {bagelSocket} from "@/helpers/socket";
// import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ref } from "vue";
// import parsePhoneNumber, { validatePhoneNumberLength } from "libphonenumber-js";
import { api } from "@monolith/helpers";
import { LoadingSpinner, CurrencyFormatter, AllergenList, Confirm } from "@monolith/components";
import Cart from "./Cart.vue";
import eftposHelpers from "@/components/_mixins/eftposHelpers";
import smartPayHelper from "@/components/_mixins/smartPayHelper";
import KeyPad from "../_layouts/KeyPad.vue";
import windCaveHelpers from "../_mixins/windCaveHelpers";
import Slug from "slug";

export default {
  name: "CheckoutModal",
  props: ["open", "close"],
  emits: ["showWebOrderModal"],
  mixins: [eftposHelpers, smartPayHelper, windCaveHelpers],
  components: { LoadingSpinner, Cart, KeyPad, CurrencyFormatter, AllergenList, Confirm },
  data() {
    return {
      showKeyPad: false,
      stripe: null,
      elements: null,
      intentLoaded: false,
      paymentProccessing: false,
      year: new Date().getFullYear(),
      dates: ["2023/12/25", "2023/12/26", "2024/1/1", "2024/1/2"],
      openModal: false,
      openSplitEftpos: false,
      openDiscountModal: false,
      openNotesModal: false,
      showLog: false,
      name: null,
      notes: null,
      email: null,
      email_receipt: false,
      cell: "",
      location: "",
      futurePickupDate: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString().split("T")[0],
      futurePickupTime: "10:00",
      futureDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split("T")[0],
      includePickupTime: false,
      shops: JSON.parse(window.localStorage.getItem("shops")),
      errors: [],
      stripeErrors: [],
      delivery: "",
      when: null,
      splitOrderCurrentTotal: null,
      paymentStatus: "pending", // pending -> partial -> full -> post -> complete (orders can be appending to, e.g. dessert),
      moneyShow: false,
      eftposShow: false,
      accountShow: false,
      voucherShow: false,
      centrapayShow: false,
      customAmount: 0,
      amount: "",
      changeDue: 0,
      searches: [],
      searchQuery: "",
      voucherSearchQuery: "",
      allergens: false,
      eftposBusy: false,
      eftposSig: false,
      sentToEftpos: 0,
      sentToCentrapay: { active: false, id: null },
      purID: null,
      refunding: false,
      kioskOrderID: "",
      paymentOptionOpened: false,
      keys: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      itemPay: false,
      itemEftposList: [],
      itemCentrapayList: [],
      channelAttached: null,
      openConfirm: false,
    };
  },
  setup() {
    const date = ref(new Date(new Date().setDate(new Date().getDate() + 2)));
    // In case of a range picker, you'll receive [Date, Date]
    const format = (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `Selected date is ${day}/${month}/${year}`;
    };
    const endDate = () => {
      return new Date("25/12/2022");
    };

    const handleDate = (modelData) => {
      date.value = modelData;
      //date.value = intlDateObj.format(date.value);
      // do something else with the data
    };
    return {
      date,
      format,
      endDate,
      handleDate,
    };
  },

  async created() {
    if (window.localStorage.getItem("futurePickup")) {
      this.$store.dispatch("setFuturePickup", true);
    }

    // Wait for socket to be ready and get the channel
  },

  beforeMount() {
    window["Beamy"] = {
      components: this,
      eftposMSG: (msg) => this.eftposHandler(msg),
      eftposSignature: () => this.eftposSigHandler(),
      handlePurID: (id) => (this.purID = id),
      handleEftposCheck: (msg) => this.handleCheckResponse(msg),
    };
  },
  async mounted() {
    this.channelAttached = false;
    // const stripeKey = process.env.VUE_APP_STRIPE_LIVE;
    // // estlint-disable-next-line
    // this.stripe = window.Stripe(stripeKey);
    // this.stripe.api_version = "2024-10-28.acacia";
  },
  methods: {
    setupChannelListeners() {
      // Get the channel from the socket store
      this.channel.on("centrapay:init_payment", (reply) => {
        let station = localStorage.getItem("station");
        if (reply.station == station) {
          this.sentToCentrapay.active = true;
          this.sentToCentrapay.id = reply.id;
        }
        this.$notify({
          text: "Centrapay Initiated: " + reply.station + " companion",
          type: "success",
          duration: 5000,
        });
      });

      this.channel.on("centrapay:cancel_payment", (reply) => {
        this.sentToCentrapay.active = false;
        this.$notify({
          text: "Centrapay Cancelled from Companion",
          type: "error",
          duration: 5000,
        });
      });

      this.channel.on("centrapay:paid", (reply) => {
        //when the paid message is received
        if (this.sentToCentrapay.active && reply.id == this.sentToCentrapay.id) {
          this.addPayment({
            type: "centrapay",
            value: this.remaining,
            id: reply.id,
          }); //add to the order data
          this.completeTransaction();
          this.$notify({
            text: "Centrapay: Payment Approved",
            type: "success",
            duration: 5000,
          });
        }
        this.sentToCentrapay.active = false; //reset the button
      });
    },
    ...mapActions(["addToCart", "increaseCartQuantity", "decreaseCartQuantity", "addPayment", "clearCart", "clearPayments"]),

    addKey(key) {
      this.amount += key;
    },

    clearInput() {
      this.amount = "";
    },

    addItemToPayment(item, remaining = false) {
      if (remaining) {
        this.sendToEftpos(item); // send the remaining amount to eftpos
        this.closePaymentOption(); // close the payment option
      } else {
        this.itemEftposList.push(item); // add item to the eftpos list
        this.customAmount += item.price; // add item price to the custom amount
        // this.sendToEftpos(item.price); // show this item is sent to eftpos
      }
    },

    removeItemFromEftpos(item) {
      const index = this.itemEftposList.findIndex((i) => i.hash === item.hash);
      if (index !== -1) {
        this.itemEftposList.splice(index, 1); // remove item from the eftpos list
        this.customAmount -= item.price; // subtract item price from the custom amount
      }
    },

    removeItemFromCentrapay(item) {
      const index = this.itemCentrapayList.findIndex((i) => i.hash === item.hash);
      if (index !== -1) {
        this.itemCentrapayList.splice(index, 1); // remove item from the centrapay list
        this.customAmount -= item.price; // subtract item price from the custom amount
      }
    },

    // when a payment button is clicked, all of the options are hidden
    openPaymentOption(option) {
      // Hide main options
      const outerDiv = document.querySelector(".details");
      if (outerDiv) {
        outerDiv.classList.add("hidden");
      }

      // reset all variables
      this.paymentOptionOpened = true;
      this.clearInput();
      this.customAmount = 0;
      this.searchQuery = "";
      this.voucherSearchQuery = "";
      this.searches = [];

      // Reset all payment option flags
      this.moneyShow = false;
      this.eftposShow = false;
      this.accountShow = false;
      this.voucherShow = false;
      this.centrapayShow = false;

      // Show the correct payment option
      if (option === "money") {
        this.moneyShow = true;
      } else if (option === "eftpos") {
        this.eftposShow = true;
        this.itemPay = true;
      } else if (option === "account") {
        this.accountShow = true;
      } else if (option === "voucher") {
        this.voucherShow = true;
      } else if (option === "centrapay") {
        // centrapay option
        this.centrapayShow = true;
        this.itemPay = true;
      }
    },

    enterCustomAmount(amount) {
      this.customAmount = amount;
    },

    // called when the back button is clicked from chosen payment option
    closePaymentOption() {
      // show the main options again
      const outerDiv = document.querySelector(".details");
      if (outerDiv) {
        outerDiv.classList.remove("hidden");
      }
      this.paymentOptionOpened = false;

      // make all flags back to false
      this.voucherShow = false;
      this.accountShow = false;
      this.eftposShow = false;
      this.moneyShow = false;
      this.centrapayShow = false;
      this.clearInput();
      this.customAmount = 0;
      this.itemPay = false;
      this.itemEftposList = [];
    },

    async search() {
      if (this.searchQuery.length > 1) {
        const search = await api.searchAccounts(this.searchQuery);
        if (search && search.rows) {
          let result = search.rows.map((acc) => (acc.key[2] == "id-name" ? { key: [acc.key[1], acc.key[0], "name-id"], value: acc.value } : acc));
          this.searches = [...new Set(result.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.searches = [];
          // console.error("No search results or error in search response", search);
        }
      } else {
        this.searches = [];
      }
    },
    async voucherSearch() {
      if (this.voucherSearchQuery.length > 1) {
        const search = await api.searchVouchers(this.voucherSearchQuery);
        if (search && search.rows) {
          let result = search.rows.map((acc) => (acc.key[2] == "id-name" ? { key: [acc.key[1], acc.key[0], "name-id"], value: acc.value } : acc));
          this.searches = result;
        } else {
          this.searches = [];
          // console.error("No search results or error in voucher search response", search);
        }
      } else {
        this.searches = [];
      }
    },
    selectDelivery(option) {
      if (option && document.querySelectorAll('input[type="radio"]') != null) {
        // document.querySelectorAll('input[type="radio"]').checked = false;
        // cannot read porperties of undefined reading checked
        // document.querySelector("." + option).checked = !document.querySelector("." + option).checked;
        this.delivery = option;
      }
    },
    activeDiscounts() {
      return this.discounts.filter((discount) => (discount.value.active ? discount : null));
    },
    applyDiscount(discount) {
      let value = 0;
      if (discount.value.type === true) {
        value = discount.value.value;
      } else {
        value = (this.total / 100) * discount.value.value;
      }
      /* only apply the discount once */
      let hasDiscount = this.payments.find((payment) => {
        return payment.type === "discount";
      });
      if (!hasDiscount) {
        this.addPayment({ type: "discount", value: value });
      }
    },
    payCash(value) {
      this.splitOrderCurrentTotal = 0;
      if (parseFloat(value) > parseFloat(this.remaining)) {
        this.changeDue = value - this.remaining;
        this.addPayment({ type: "cash", value: parseFloat(this.remaining) });
        this.$notify({
          text: `Change Due: $${this.changeDue.toFixed(2)} `,
          type: "success",
          duration: -1,
        });
      } else {
        this.addPayment({ type: "cash", value: parseFloat(value) });
      }
      let now = Date.now();
      this.channel.push("float:new", {
          _id: `float:${now}`,
          station: Slug(localStorage.getItem("station")),
          doc_type: "credit",
          name: "POS",
          timestamp: new Date().toISOString(),
          value: parseFloat(value),
      });
      if (this.remaining == 0) {
        this.completeTransaction();
      }
    },
    refund(value) {
      this.refunding = true;
      //this.splitOrderCurrentTotal = 0;
      //this.addPayment({ type: "refund", value: (-1 * value) });
      //this.refunding = true;
      //this.splitOrderCurrentTotal = 0;
      //this.addPayment({ type: "refund", value: (-1 * value) });
      //this.helperRefund(value);
      let lineItems = this.cartOrder.products.map((prod) => {
        return {
          name: prod.item,
          sku: prod.id,
          price: parseInt(prod.quantity * prod.price * 100).toString(),
          qty: prod.quantity.toString(),
          tax: "15.0",
        };
      });
      this.cartOrder.payments.map((payment) => {
        if (payment.type === "centrapay") {
          this.channel
            .push("centrapay:refund", { id: payment.id, amount: (100 * payment.value).toString(), lineitems: lineItems })
            .receive("ok", (reply) => {
              this.refunding = false;
              this.$notify({
                text: `Centrapay Refund Successful`,
                type: "success",
                duration: 5000,
              });
              this.addPayment({ type: "centrapay_refund", value: -1 * (reply.reply.value.amount / 100), id: reply.reply.id });
            })
            .receive("error", (error) => {
              this.refunding = false;
              this.$notify({
                text: `Centrapay Refund Failed`,
                type: error,
                duration: 5000,
              });
            });
        } else if (payment.type === "eftpos") {
          if (this.activeTerminal === "eftpos") {
            this.helperRefund(value);
          } else if (this.activeTerminal === "smartpay") {
            this.smartPayRefund(value);
          }
        }
      });
    },
    splitOrder(hash) {
      let foundLineItem = this.products.find((p) => {
        return p.hash === hash;
      });
      if (foundLineItem) {
        this.splitOrderCurrentTotal += foundLineItem.price * foundLineItem.quantity;
      } else {
        // left empty
      }
    },
    sendToAccount(name, id, value) {
      let currAcc = {
        ID: id,
        name: name,
        doc_type: "debit",
        value: value,
        date: new Date().toISOString(),
      };
      this.name = name;
      this.channel.push("account:doc", currAcc);
      this.splitOrderCurrentTotal = 0;
      this.addPayment({ type: "account", value: value, id: id, name: name });
    },
    sendToVoucher(name, id, value, voucherBalance) {
      if (voucherBalance <= 0) {
        this.$notify({
          text: `Voucher had no remaining credit`,
          type: "warn",
          duration: 5000,
        });
        return;
      }
      if (this.payments.find((payment) => payment.id === id)) {
        this.$notify({
          text: `Voucher already used`,
          type: "warn",
          duration: 5000,
        });
        return;
      }

      let newValue = value > voucherBalance ? voucherBalance : value;
      let currAcc = {
        ID: id,
        name: name,
        doc_type: "debit",
        value: newValue,
        date: new Date().toISOString(),
      };
      this.channel.push("voucher:doc", currAcc);
      this.voucherUsed = true;
      this.splitOrderCurrentTotal = 0;
      this.addPayment({ type: "voucher", value: newValue, id: id, name: name });
      this.voucherShow = false;
    },
    sendToCentrapay() {
      this.channel.push("centrapay:init_payment", { products: this.products });
      this.sentToCentrapay.active = true;
    },
    cancelCentrapay() {
      this.channel.push("centrapay:cancel_payment", { id: this.sentToCentrapay.id });
      this.sentToCentrapay.active = false;
    },
    chargeStripe(value) {
      window.Android.chargeStripe((parseFloat(value) * 100).toFixed(0).toString());
    },
    sendToEftpos(value) {
      // this.payLater();
      if (this.activeTerminal === "eftpos_nz") {
        this.handleEftposPayment(value);
      } else if (this.activeTerminal === "smartpay") {
        this.smartPayPurchase(value);
      } else if (this.activeTerminal === "windcave") {
        let n = this.initTransaction(value);
        this.postTransaction(n);
      }
    },

    eftposCashOut(cashoutAmount) {
      if (this.activeTerminal === "eftpos_nz") {
        // this.handleEftposPayment(this.splitTotal, cashoutAmount);
        //need to implement cashout amount
      } else if (this.activeTerminal === "smartpay") {
        this.smartPayCashout(parseInt(this.splitTotal) + parseInt(cashoutAmount), cashoutAmount);
      }
    },

    acceptSig() {
      this.eftposSig = false;
      if (this.activeTerminal === "eftpos_nz") {
        this.helperAcceptSig();
      } else if (this.activeTerminal === "smartpay") {
        this.smartPayAcceptSig();
      } else if (this.activeTerminal === "windcave") {
        this.acceptWindcaveSig();
      }
    },
    declineSig() {
      this.eftposSig = false;
      if (this.activeTerminal === "eftpos_nz") {
        this.helperDeclineSig();
      } else if (this.activeTerminal === "smartpay") {
        this.smartPayDeclineSig();
      } else if (this.activeTerminal === "windcave") {
        this.declineWindcaveSig();
      }
    },
    eftposSigHandler() {
      this.eftposSig = true;
    },
    checkEftposFee(msg) {
      if (parseFloat(msg) != parseFloat(this.sentToEftpos)) {
        // if the money payed is not the same amount as what was sent to eftpos machine
        let feePrice = parseFloat(msg) - parseFloat(this.sentToEftpos);
        var fee = { id: "product:fee", modifiers: {}, price: feePrice };
        try {
          // add the fee to the cart as a product with an id, modifiers, price and hash
          this.addToCart(fee);
        } catch (error) {
          console.log(error);
        }
      }
    },

    cancelEftpos() {
      if (this.activeTerminal === "eftpos_nz") {
        this.helperCancelEftpos();
      } else if (this.activeTerminal === "smartpay") {
        console.log("investigate smart pay cancel"); //no cancel endpoint for smartpay
        // this.smartPayCancel();
      } else if (this.activeTerminal === "windcave") {
        this.cancelWindcaveTransaction();
      }
    },
    manualEftposPayment(value) {
      // this.helperCheckEftposLastPayment(value);
      this.addPayment({ type: "eftpos", value: value });
    },
    payLater() {
      this.completeTransaction();
    },
    sendToEftposSplit(value) {
      this.addPayment({ type: "eftpos", value: value });
    },
    giveChange(value) {
      this.addPayment({ type: "change", value: value });
    },
    checkRequirements() {},
    transactionValidation() {
      this.errors = [];

      if (this.siteSettings.nameRequired && !this.name) {
        this.errors.push("Name is required");
      }
      if (!this.delivery && this.siteSettings.delivery_options.length !== 0) {
        if (this.siteSettings.delivery_options.length == 1) {
          this.delivery = this.siteSettings.delivery_options[0];
        } else {
          this.errors.push("Delivery is required");
        }
      }
    },
    completeTransaction() {
      if (this.getKiosk) {
        if (this.getKioskOrderDetails.orderType == "dine-in") {
          this.delivery = this.getKioskOrderDetails.orderType;
          this.name = this.getKioskOrderDetails.orderDetails;
        } else if (this.getKioskOrderDetails.orderType == "takeaway") {
          this.delivery = this.getKioskOrderDetails.orderType;
          this.name = this.getKioskOrderDetails.orderDetails;
        }
      }

      // reply = false, ??
      if (this.isProdTracked) {
        this.transactionValidation();
      } else {
        this.errors = [];
      }

      if (this.holdingAccount) {
        this.channel.push("account:doc", this.holdingAccount);
      }

      let prods = this.products.map((p) => {
        if (this.trackedCategories.includes(p.category)) {
          return { ...p };
        } else {
          return { ...p, complete: true };
        }
      });

      this.eftposBusy = false;
      if (this.errors.length === 0) {
        this.openModal = false;
        //   "On callback from complete transaction - need to clear the payments and cart"
        // );
        let delivery = this.delivery;
        if (this.futurePickup) {
          delivery = "future-pickup";
        }
        var now = new Date();
        now.toISOString();

        var order_data = {
          version: 2,
          name: this.name,
          notes: this.notes,
          location: this.futurePickup ? this.location : localStorage.getItem("site"),
          complete: !this.isProdTracked,
          paymentStatus: this.remaining === 0 ? "paid" : "partial",
          delivery: delivery,
          products: prods,
          payments: this.payments,
          pickup_date: this.futurePickup ? this.futurePickupDate : this.date.toLocaleDateString("sv-SE"),
          pickup_time: this.futurePickup && this.includePickupTime ? this.futurePickupTime : null,
          total: this.total,
          events: {},
          allergens: this.customerAllergens,
        };

        // a different listener can respond to the invoice */
        /* send to web socket */
        if (this.cartOrder && this.cartOrder._id) {
          order_data["events"]["created_at"] = this.cartOrder["created_at"];
          order_data["events"]["updated_at"] = now.toISOString();
          order_data["_id"] = this.cartOrder._id;
          // this.cartOrder['events']['updated_at'] = now.toISOString()
          //let doc = { ...this.cartOrder, ...order_data };
          this.channel.push("order:update", order_data);
          this.handlePaymentCompletion();
        } else {
          order_data["events"] = {
            created_at: now.toISOString(),
            updated_at: now.toISOString(),
          };

          this.channel.push("order:new", order_data).receive("ok", async (reply) => {
            if (this.getKiosk) {
              this.$store.dispatch("setKioskDetails", {
                orderType: this.delivery,
                orderDetails: this.name,
                orderID: reply.reply.rows[0].id,
              });
              this.$router.push({ path: "/kioskReceipt" });
            }
            //let orderUser = { ...this.user };
            //!orderUser["orders"] ? (orderUser["orders"] = [reply.reply.rows[0].id]) : orderUser["orders"].push(reply.reply.rows[0].id);
            this.handlePaymentCompletion();
          });
        }
      }
      this.$store.dispatch("clearAllergensList");
      this.closePaymentOption();
    },

    handlePaymentCompletion() {
      this.clearCart();
      this.clearPayments();
      this.splitOrderCurrentTotal = 0;
      this.voucherShow = false;
      this.voucherSearchQuery = "";
      this.paymentProccessing = false;
      this.$store.dispatch("setHoldingAccount", null);
      if (this.getSatellite) {
        this.$store.dispatch("setCurrentTable", {});
        this.$router.push("/floorplan");
      }
    },
  },

  computed: {
    ...mapGetters({
      siteSettings: "siteSettings",
      payments: "cartPayments",
      products: "cartProducts",
      discounts: "discounts",
      cartOrder: "cartOrder",
      eftposSettings: "eftposSettings",
      orderName: "orderName",
      orderNotes: "orderNotes",
      orderDelivery: "orderDelivery",
      futurePickup: "futurePickup",
      user: "user",
      trackedCategories: "trackedCategories",
      getSurcharge: "getSurcharge",
      getKiosk: "getKiosk",
      getKioskOrderDetails: "getKioskOrderDetails",
      getSatellite: "getSatellite",
      socketConnected: "socketConnected",
      localSettings: "localSettings",
      holdingAccount: "holdingAccount",
      currency: "currency",
      customerAllergens: "customerAllergens",
      conflictingAllergens: "conflictingAllergens",
      conflictingAllergenList: "conflictingAllergenList",
      getCustomerAllergenList: "getCustomerAllergenList",
    }),
    isProdTracked() {
      return this.products.some((product) => {
        return this.trackedCategories.some((category) => {
          return product.category === category;
        });
      });
    },

    activeTerminal() {
      if ("active_terminal" in this.localSettings[0]) {
        return this.localSettings[0].active_terminal;
      } else {
        return this.localSettings[0].terminal_providers[0];
      }
    },

    surchargeTotal() {
      const total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      //return this.siteSettings.surcharge_rate * total;
      return 0.15 * total;
    },
    ccTotal() {
      const total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      return 0.03 * total;
    },
    total() {
      let total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      if (this.siteSettings.surcharge) {
        total += this.surchargeTotal;
      }
      return total;
    },
    paid() {
      return this.payments.reduce((total, p) => {
        return total + p.value;
      }, 0);
    },
    remaining() {
      return this.total - this.paid;
    },
    /* split total is either the remaining total or the current total for items that have been split but not yet paid for */
    splitTotal() {
      if (this.splitOrderCurrentTotal && this.splitOrderCurrentTotal > 0) {
        return this.splitOrderCurrentTotal;
      }
      return this.remaining;
    },
    physicalShops() {
      let shops = {};
      for (let key in this.shops) {
        if (this.shops[key].online) {
          shops[key] = this.shops[key];
        }
      }
      return shops;
    },
  },
  watch: {
    socketConnected: function () {
      if (this.socketConnected) {
        this.setupChannelListeners();
        this.channelAttached = true;
      }
    },
    amount: function () {
      this.customAmount = this.amount;
    },
    searchQuery: function () {
      this.search();
    },
    voucherSearchQuery: function () {
      this.voucherSearch();
    },
    async open() {
      this.openModal = true;
      this.customAmount = 0;
      this.moneyShow = false;
      this.eftposShow = false;
      this.openNotesModal = true;
      this.name = this.orderName != null && this.orderName.length > 0 ? this.orderName : null;
      this.notes = "";
      this.delivery = this.orderDelivery;
      if (this.futurePickup) {
        if (this.cartOrder && this.cartOrder.pickup_date) {
          this.futurePickupDate = this.cartOrder.pickup_date;
        }
        if (this.cartOrder && this.cartOrder.pickup_time) {
          this.futurePickupTime = this.cartOrder.pickup_time;
          this.includePickupTime = true;
        }
        if (this.cartOrder && this.cartOrder.location) {
          this.location = this.cartOrder.location;
        }
      }
      // this.sentToCentrapay = false;
      if (this.delivery != null) {
        this.selectDelivery(this.delivery);
      }
    },
    openModal() {
      if (!this.openModal) {
        this.intentLoaded = false;
        this.eftposSig = false;
      }
    },
    close() {
      this.openModal = false;
      this.intentLoaded = false;
    },
    payments() {
      let companion = { products: this.products, payment: this.payments };
      if (this.siteSettings.surcharge) {
        companion["surcharge"] = true;
        companion["surchargeTotal"] = this.surchargeTotal;
      }
      this.channel.push("cart:state", companion);
    },

    /***orderName() {
      this.name = this.orderName;
    },
    orderNotes() {
      this.notes = this.orderNotes;
    },
    orderDelivery() {
      this.delivery = this.orderDelivery;
    },***/
  },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

button {
  box-shadow: none;
  span {
    color: var(--secondary-text-colour);
  }
}

.hidden {
  display: none !important;
}

.remaining {
  display: flex;

  margin-top: 0px;
  border-bottom: 2px solid #ccc;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  text-align: right;

  span.label {
    flex: 0 1 auto;
    display: inline-block;
    text-align: left;
  }

  span.value {
    flex: 1 0;
    display: inline-block;
  }
}

.actions {
  margin-top: 1rem;
}
.log {
  list-style: none;
  text-transform: capitalize;
  padding: 0px;
  text-align: right;
}

.modal {
  .container {
    border-radius: 1rem;
    width: 50%;
    align-items: center;
  }

  #eftpos-spinner {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-colour);
    border-radius: 1rem;
    box-shadow: var(--box-shadow);
    opacity: 0.8;
  }
  .pay-btn {
    padding: 1rem;
    border-radius: 0.5rem;
    border: none;
    background-color: var(--action-colour);
    color: var(--primary-colour);
    font-weight: bold;
    font-size: 1.2rem;
    box-shadow: var(--box-shadow);
    margin: 1rem;
    cursor: pointer;
  }
  .product-list {
    width: 100%;
    overflow: auto;
  }

  .product-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 1rem;
    .items {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 1rem;
      border-radius: 1rem;
      background-color: var(--primary-colour);
      margin: 0.5rem;
      width: calc(100% - 3rem);
      box-shadow: var(--box-shadow);
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 8rem;
        width: 100%;
        overflow-y: auto;
        ul {
          margin: 0;
          li {
            list-style: circle;
            margin: 0.25rem 0;
          }
        }
      }
      h4,
      p {
        margin: 0.25rem;
        color: var(--action-colour);
      }

      img,
      .no-image {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 8rem;
        height: 8rem;
        object-fit: cover;
        margin: 0.5rem;
        border-radius: 0.5rem;
        background-color: var(--action-colour);
        color: var(--primary-colour);
      }
    }
  }

  .exitPaymentOption {
    font-size: 2rem;
    text-align: center;
    display: block;
    margin-left: 0;
    // margin: auto;
    cursor: pointer;
    color: var(--action-colour);
  }
  .time {
    color: var(--action-colour);
    font-size: 1.5rem;
    text-align: center;
    display: block;
    margin: 0.5rem auto;
  }

  div.outer {
    display: flex;
    background-color: var(--secondary-colour);
    min-width: 80vw;
    max-width: 90vw;
    min-height: 50vh;
    max-height: 90vh;
    padding: 1rem;
    justify-content: space-around;
    align-items: baseline;
    border-radius: 0.5rem;
    flex-direction: row;
    flex-wrap: wrap;

    .bump-right {
      flex: 1 0 100%;
      // left: 50%;
    }
    form {
      display: contents;
    }

    h2 {
      padding-top: 0px;
    }

    div.details {
      flex: 1 1;
      padding: 1rem;
      overflow-y: auto;

      .logged-in {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 10px;
        .logged-in-user {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin: 0.5rem 0;
        }
        .user-info {
          margin-left: 1rem;
          font-size: x-large;
        }

        .notes {
          input {
            background-color: var(--primary-colour);
            color: var(--primary-colour);
          }
          .allergies {
            label {
              margin: 0;
              font-size: x-large;
              h4 {
                text-wrap: nowrap;
              }
            }
          }
          div {
            textarea {
              // padding: 0.5rem;
              margin-left: 1rem;
              font-size: small;
              width: 15rem;
              &::placeholder {
                font-size: small;
              }
            }
          }
        }
        div {
          button {
            width: 40rem;
          }
        }
      }

      .svg-spinner {
        background-color: var(--opacity-background);
        z-index: 10;
        position: absolute;
        height: 100vh;
        width: 100vw;
        top: 0;
        left: 0;
        .loading-spinner {
          z-index: 100;
          position: absolute;
        }
      }

      h4 {
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
      }

      .notes,
      .email,
      .cell,
      .eftpos,
      .money,
      .location {
        input,
        select {
          font-family: "Lato";
          margin-bottom: 1rem;
          border: 1px solid var(--boder-colour);
          width: calc(100% - 2rem);
          padding: 1rem 1rem 1rem 1rem;
          font-size: 1.5rem;
          height: 2rem;
          border-radius: 0.5rem;
          max-height: 30%;
        }
        textarea {
          font-family: "Lato";
          margin-bottom: 1rem;
          border: 1px solid var(--border-colour);
          width: calc(100% - 2rem);
          padding: 1rem 1rem 1rem 1rem;
          font-size: 1.5rem;
          height: 2rem;
          resize: none;
          border-radius: 0.5rem;
        }
        button {
          margin: auto;
          margin-top: 0.5rem;
        }
        .allergies {
          display: flex;
          flex-direction: row;
          font-size: 1.5rem;
          justify-content: flex-start;
          align-items: flex-start;
          font-size: 1.25rem;
        }
      }

      .notes {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
        grid-auto-flow: row;
        grid-column-gap: 1rem;
        .allergies {
          text-wrap: nowrap;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          input {
            width: 2rem;
            margin: 0.5rem;
          }
          textarea {
            padding: 0.5rem;
            margin-left: 1rem;
            width: 14rem;
          }
        }

        .customer-allergens {
          width: 100%;
          grid-column-start: 1;
          grid-column-end: 3;
          background-color: var(--primary-colour);
          border-radius: 0.5rem;
          padding: 0.75rem 0;
          :deep(.allergen-list) {
            margin-left: 1rem;
          }
        }
      }

      .delivery {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
        grid-auto-flow: row;
        grid-column-gap: 1rem;
        grid-row-gap: 1rem;
        margin-top: 1rem;

        input {
          appearance: none;

          border-radius: 50%;
          width: 1rem;
          height: 1rem;
          border: 2px solid var(--action-colour);
          margin-right: 0.5rem;
        }
        input:checked {
          background-color: var(--action-colour);
          // border: 0.6rem solid var(--action-colour);
        }
        span {
          text-transform: capitalize;
          display: inline-block;
          padding: 1rem;
          border: 1px solid #ccc !important;
          background-color: var(--primary-colour);
          font-size: 1.4rem;
          border-radius: 0.5rem;
        }
      }

      .future-pickup-options {
        display: flex;
        justify-content: space-around;
        gap: 0.5rem;
        margin-top: 1rem;

        .fp-options-inner {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background-color: var(--primary-colour);
          border-radius: 0.5rem;
          box-shadow: var(--box-shadow);
          h4 {
            margin: 0.5rem;
            color: var(--action-colour)
          }
          .time-toggle {
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--action-colour);
            margin: 0.5rem;
          }
        }

        .date-picker,
        select {
          padding: 0.5rem;
          font-size: 1.2rem;
          border-radius: 0.5rem;
          border: none;
          color: var(--secondary-text-colour);
        }
      }

      .discounts {
        display: grid;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        grid-auto-flow: row;
        grid-column-gap: 1rem;
        grid-row-gap: 1rem;

        button {
          margin: 0px;
        }
        button:first-child {
          flex: 0.5 1;
          margin-right: 1rem;
        }
        button:nth-child(1) {
          flex: 0.5 1;
        }
        button:last-child {
          flex: 0.5 1;
          margin-right: 0px;
        }
      }

      .complete {
        width: 100%;
        margin: 1rem 0;
        height: 5rem;
      }

      .payments {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;

        .button-spacing {
          display: flex !important;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          text-align: center;
          text-wrap: wrap;
          .sig-btns {
            display: flex;
          }
        }
        .pencil-button {
          background-color: var(--secondary-colour);
          border-radius: 0.5rem;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 1rem;
        }

        button {
          margin: 0px;
          width: calc(50% - 5px);
          flex-grow: 1;
          padding: 0.5rem 1rem;

          .discount-tag {
            margin: 0;
          }
        }
      }

      .stripe {
        button {
          margin: 10px 0px;
        }
        margin-top: 1rem;
      }
    }
    .errors {
      color: var(--warning-colour);
      margin: 1rem;
      font-size: 1.5rem;
    }

    div.cart {
      flex: 0 1;
      padding: 0.5rem 0.5rem 0.5rem 0.5rem;
      min-width: 25%;
    }

    .paymentOption {
      min-width: 70%;
      overflow: hidden;
      h2 {
        margin-top: 1rem;
      }
      .money {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 1rem;
        .cashLeft {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          max-width: 80%;
          button {
            height: auto !important;
          }
          .dollarBillOptions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
          }
        }
        .cashRight {
          margin: 0;
        }
      }
      .eftpos {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        // align-items: center;
        gap: 1rem;
        .eftposLeft {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          // align-items: center;

          gap: 1rem;
          max-width: 80%;
          margin: 0;
          button {
            height: auto !important;
          }
          .itemsAddedToEftpos {
            display: flex;
            flex-direction: column;
            ul {
              list-style: none;
              padding: 0;
              margin: 0;
              li {
                margin: 0.25rem 0.5rem;
              }
            }
            .quantity-icon {
              color: var(--warning-colour);
            }
          }
        }
        .eftposRight {
          margin: 0;
        }
      }
      .centrapay {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        gap: 1rem;
        .centrapayLeft {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          // align-items: center;

          gap: 1rem;
          max-width: 80%;
          margin: 0;
          button {
            height: auto !important;
          }
          .itemsAddedToCentrapay {
            display: flex;
            flex-direction: column;
            ul {
              list-style: none;
              padding: 0;
              margin: 0;
              li {
                margin: 0.25rem 0.5rem;
              }
            }
            .quantity-icon {
              color: var(--warning-colour);
            }
          }
        }
        .centrapayRight {
          margin: 0;
        }
      }
      .account {
        #accountSearch {
          background-color: var(--primary-colour);
          border: none;
          height: 3rem;
          color: var(--text-colour);
        }
      }
      .voucher {
        #voucherSearch {
          background-color: var(--primary-colour);
          border: none;
          height: 3rem;
          color: var(--text-colour);
        }
      }
      .keypad {
        border-radius: 1rem;
        margin-right: 1rem;
        padding-bottom: 1rem;
        h2 {
          margin: 1rem;
        }

        .keypad-display {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          box-shadow: var(--box-shadow);
          border-radius: 1rem;
          margin: 1rem;
          background-color: var(--primary-colour);
        }
        .keypad-buttons {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1rem;
          button {
            padding: 1rem;
            font-size: 1.5rem;
            border: none;
            box-shadow: var(--box-shadow);
            border-radius: 0.5rem;
            background-color: var(--primary-colour);
            color: var(--text-colour);
            cursor: pointer;
            &:active {
              background-color: var(--action-colour);
            }
          }
        }
      }
    }
  }
}
.no-money,
.no-eftpos,
.no-voucher,
.no-centrapay,
.no-account {
  display: none;
}

@media only screen and (max-width: 995px) {
  .cust-info {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)) !important;
  }
}

@media screen and (orientation: landscape) {
  .outer {
    flex-direction: row;
  }
}

@media screen and (orientation: portrait) {
  .modal {
    .outer {
      flex-direction: column-reverse;
      .cart {
        display: none;
      }
    }

    & > div {
      display: flex;
      flex-direction: column;
      background-color: var(--primary-colour);
      width: 100%;
      padding: 1rem;
      overflow-y: scroll;
    }

    div.outer {
      form {
        display: block;
        margin: 0;
        div.details {
          flex: 0;
          .logged-in {
            .logged-in-user {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              gap: 10px;
            }
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 10px;
            div {
              button {
                width: 20rem;
                margin-left: 0;
              }
            }
            .notes {
              width: 100%;
            }
          }

          .notes,
          .email,
          .cell,
          .location {
            input,
            select {
              font-size: 1rem;
            }
            textarea {
              font-size: 1rem;
            }

            .notes {
              display: grid;
              grid-template-areas:
                "cart"
                "cust-info";
            }
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          }
        }
      }
      div.cart {
        min-width: inherit;
      }
    }
  }
}

h2 {
  margin-top: 0px;
  padding-top: 1rem;
}

button {
  padding: 1rem;
  width: calc(50% - 5px);
  font-size: 1.5rem;
  min-height: 4rem !important;

  &.is-primary {
    margin-bottom: 1rem;
  }
}

#showmethemoney {
  height: 80%;
  width: 100%;
  text-align: center;
}

.money,
.eftpos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-flow: row;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  flex-wrap: wrap;
  justify-content: stretch;

  select.dollarBills {
    max-height: 3rem;
    width: 100%;
  }

  button {
    margin: 0px !important;
    height: 4rem;
    width: 10rem;
  }
}

.no-money,
.no-eftpos,
.no-voucher,
.no-account {
  display: none;
}

.eftpos {
  .eftposLeft {
    justify-content: center;
    margin: auto;
  }
  .eftposRight {
    max-width: 80vw;
    .keypad {
      max-width: 80vw;
      margin: 0.5rem;
      padding: none;
      .keypad-buttons {
        button {
          max-width: 5.5rem;
        }
      }
    }
  }
}
.money {
  .cashLeft {
    justify-content: center;
    margin: auto;
  }
  .cashRight {
    max-width: 80vw;
    .keypad {
      max-width: 80vw;
      margin: 0.5rem;
      padding: none;
      .keypad-buttons {
        button {
          max-width: 5.5rem;
        }
      }
    }
  }
}
</style>
